export const formatPhone = (phone: string): string => phone.replace('0', '+61');
